import React from 'react';
import './CustomCheckbox.css';

export interface ICustomCheckboxProps {
  id?: string
  title: string;
  value: boolean;
  onChange: (val: boolean) => void;
  disabled?: boolean;
  required?: boolean;
}

const CustomCheckbox: React.FC<ICustomCheckboxProps> = ({ id = '0', title, value, onChange, disabled, required = false }) => {
  return (
    <div className="checkbox">
      <input
        // title='confirm-checkbox'
        className="custom-checkbox"
        id={"confirm-checkbox-" + id}
        type="checkbox"
        checked={value}
        onChange={() => { }}
      />
      <label
        htmlFor={"confirm-checkbox-" + id}
        style={{
          fontFamily: 'Gotham Pro Regular',
          fontSize: '14px',
          lineHeight: '16px',
          color: required ? '#red' : '#000'
        }}
        onClick={() => !disabled && onChange(!value)}>{title}</label>
    </div>
  );
}

export default CustomCheckbox;
